export class Empresa {}
